<template>
  <div class="user-manual-wrap">
    <form style="width: 30%" @submit.prevent="resetPassword">
      <div class="form-group">
        <h3 class="text-center">請輸入新密碼</h3>
        <hr>
        <input type="password" class="form-control" v-model="newPass" placeholder="新密碼" required>
        <p></p>
        <input type="password" class="form-control " v-model="newPass2" placeholder="確認新密碼" required>
      </div>
      <button class="btn btn-primary" style="width: 100%" type="submit">更新</button>
    </form>
  </div>
</template>

<script>
export default {
  name: 'Password',
  data() {
    return {
      newPass: '',
      newPass2: '',
      passwordSame: true,
    };
  },
  methods: {
    resetPassword(val) {
      if (this.newPass === this.newPass2) {
        this.instance.patch(`/api/user/${this.user.id}/`, {
          password: this.newPass,
        })
        .then((res) => {
          this.$store.commit('SET_MESSAGE', {
            type: 'success',
            context: '更新成功',
          });
          // this.$router.push({ name: 'Main' });
        })
        .catch(() => {
          this.$store.commit('SET_MESSAGE', {
            type: 'error',
            context: '更新失敗',
          });
        });
      } else {
        this.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: '請確認新密碼一致',
        });
      }
    },
  },
  computed: {
    user() {
      return this.$store.state.user.user;
    },
    instance() {
      return this.$store.state.instance;
    },
  },
};
</script>



// WEBPACK FOOTER //
// Password.vue?43828950